import { getExclusionList } from './getExclusionList'

export function excludeQueryParams({
  excludeType,
  forceQueryParams,
  query,
  excludeQueryParams,
}: {
  excludeType?: string
  forceQueryParams?: string[]
  query: Record<string, any>
  excludeQueryParams?: string[]
}): Record<string, any> {
  const outQuery = { ...query }
  const exclusionList = getExclusionList(excludeType).concat(
    getExclusionList('alwaysExcluded'),
  )

  exclusionList.forEach((key) => {
    if (!forceQueryParams?.includes(key)) {
      delete outQuery[key]
    }
  })

  excludeQueryParams?.forEach((param) => {
    if (!forceQueryParams?.includes(param)) {
      delete outQuery[param]
    }
  })
  return outQuery
}
